<div class="delivery-modal modal-app-availability">
  <h5 class="label-text">Get Promoportal for {{platformName}} and browse faster.</h5>

  <div class="modal-buttons-wrapper">
    <ion-button expand="block"
      (click)="onOkButtonClick()"
      class="button apply">
      Get {{platformName}} App
    </ion-button>

    <ion-button expand="block"
      (click)="onCancelButtonClick()"
      class="button cancel">
      Cancel
    </ion-button>
  </div>
</div>
